export { default as tabsSet } from './tabsSet';

export const FILTERS = [
  {
    key: 'all',
    value: 'all'
  },
  {
    key: 'standard',
    value: 'standard',
  },
  {
    key: 'counter',
    value: 'counter',
  },
  {
    key: 'section',
    value: 'section',
  },
];

export const FILTERKEYS = {
  'standard': 'Standard',
  'counter' : 'Counter',
  'section' : 'Section',
};



// WEBPACK FOOTER //
// ./src/containers/elements/Tabs/constants/index.js